import { useAppSelector } from "../redux/store.tsx";

export default function useAgeCheckResponse() {
  const response = useAppSelector((state) => state.shoppingCart.shoppingCartConfirmation.response);

  return response?.response;
}
